import { render } from "./App.vue?vue&type=template&id=65814142"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "/home/harry/Desktop/Vue JS/Matrix Digital/Alearif zain portal/alearif-zain/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__